import Model from './Model'
import * as PostType from '@/utils/consts/PostType'
import Comment from '@/models/Comment'
import PostReport from '@/models/PostReport'

export default class Post extends Model {
  resource() {
    return 'posts'
  }

  comments() {
    return this.hasMany(Comment)
  }

  reports() {
    return this.hasMany(PostReport)
  }

  get postTypeString() {
    if (this.post_type === PostType.PRAYER) {
      return 'Prayer'
    } else if (this.post_type === PostType.STORY) {
      return 'Story'
    } else if (this.post_type === PostType.IDEA) {
      return 'Idea'
    }
  }
}
